import crudder from 'tools/crudder'

const API_URL = process.env.PUBLIC_URL
const API_PATH = '/api'

const errorHandler = apiResponse => {
  // console.log('errorHandler', apiResponse)
  if (apiResponse?.error && apiResponse?.error?.length !== 0) {
    throw apiResponse
  } else {
    return apiResponse
  }
}

const getTicket = async (id) => {
  const pathTicket = `${API_PATH}/tickets/${id}`

  const apiTickets = crudder(API_URL)
  const search = apiTickets(pathTicket)

  return search.get()
    .then(errorHandler)
}

export default getTicket
